// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3tDxD","head":"ProcedureTableInfo_head__2TrkB"};